 module.exports = {
    drawChart: function(chartData, cumulativeProbability, categoryName) {
    var chart = AmCharts.makeChart( "chartdiv", {
      "type": "serial",
      "theme": "light",
      "sequencedAnimation": true,
      "startDuration": 0,
      "startEffect": "easeInSine",
      "dataProvider": chartData,
      "precision": 2,
      "valueAxes": [ {
        "gridAlpha": 0.2,
        "dashLength": 0,
        "labelsEnabled": false
      } ],
      "graphs": [ {
        "balloonText": categoryName +" : [[category]]",
        "lineThickness": 3,
        "valueField": "value"
      }, {
        "balloonText": "",
        "fillAlphas": 1,
        "type": "column",
        "valueField": "vertical",
        "fixedColumnWidth": 2,
        "labelText": cumulativeProbability + '%',
        "labelOffset": 20
      } ],
      "chartCursor": {
        "enabled": true,
        "categoryBalloonEnabled": false,
        // "cursorAlpha": 0,
        // "zoomable": false
      },
      "categoryField": "category",
      "categoryAxis": {
        "gridAlpha": 0.05,
        "startOnAxis": true,
        "tickLength": 5,
        // "labelFunction": function( label, item ) {
        //   return '' + Math.round( item.dataContext.category * 10 ) / 10;
        // }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/compare/compareChart.js